export const START = 'held';
export const BOOK = 'booked';